module.exports = __webpack_public_path__ + "static/media/join-in-img8-1.1525ee06.jpg";